import { validatePasswordRules } from "utils/data/User";

const email_regex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

export const validateUserStandardRegistration = (form) => {
  if (typeof form.first_name !== "string" || form.first_name.length <= 0)
    return { isValid: false, error: "errorValidationFirstname" };
  if (typeof form.last_name !== "string" || form.last_name.length <= 0)
    return { isValid: false, error: "errorValidationLastname" };

  if (typeof form.password !== "string")
    return { isValid: false, error: "errorValidationPassword" };

  if (typeof form.email !== "string")
    return { isValid: false, error: "errorValidationEmail" };
  if (form.email.length === 0)
    return { isValid: false, error: "errorEmptyEmail" };
  if (form.email.match(email_regex) === null)
    return { isValid: false, error: "errorValidationEmail" };

  return { isValid: true, error: "" };
};

export const validateAdminRegistration = (form, options = {}) => {
  const { checkPasswordValidity = true } = options;
  const { email } = form;
  const firstName = form.first_name || form.firstName;
  const lastName = form.last_name || form.lastName;
  const { password } = form;
  const organization = form.organization || form.company;

  if (typeof email !== "string" || email.match(email_regex) === null)
    return { isValid: false, error: "errorValidationEmail" };
  if (typeof firstName !== "string" || firstName.length <= 0)
    return { isValid: false, error: "errorValidationFirstname" };
  if (typeof lastName !== "string" || lastName.length <= 0)
    return { isValid: false, error: "errorValidationLastname" };
  if (typeof organization !== "string" || organization.length <= 0)
    return { isValid: false, error: "errorValidationOrganization" };
  if (
    checkPasswordValidity &&
    (typeof password !== "string" ||
      !validatePasswordRules(password, [
        "min8",
        "lowercase",
        "uppercase",
        "digits",
      ]))
  )
    return { isValid: false, error: "errorValidationNewPassword" };

  return { isValid: true, error: "" };
};

export const validateAdminPayement = (form) => {
  if (typeof form.full_name !== "string" || form.full_name.length <= 0)
    return { isValid: false, error: "errorValidationLastname" };
  if (typeof form.address !== "string" || form.address.length <= 0)
    return { isValid: false, error: "errorValidationAddress" };
  if (typeof form.zip_code !== "string" || form.zip_code.length <= 0)
    return { isValid: false, error: "errorValidationZipcode" };
  if (!form.country.code || form.country.code.length <= 0)
    return { isValid: false, error: "errorValidationCountry" };
  if (
    typeof form.cardholder_name !== "string" ||
    form.cardholder_name.length <= 0
  )
    return { isValid: false, error: "errorValidationCardholder" };

  return { isValid: true, error: "" };
};
